import { TicketInboxFilter } from "@jugl-web/rest-api/tickets/models/common-types/TicketInboxFilter";

export const MAX_TICKET_TITLE_LENGTH = 200;
export const MAX_TICKET_DESCRIPTION_LENGTH = 5_000;

export const TICKETS_FILTER_IDS: TicketInboxFilter[] = [
  "all",
  "assigned_to_user",
  "unassigned",
  "todo-today",
  "recents",
  "in_progress",
  "on_customer",
  "on_hold",
  "issued",
  "resolved",
];
